import type { TranslationDictionary } from './types'

export const th: TranslationDictionary = {
  // ── Shell / header ────────────────────────────────────────────────────────
  appTitle: 'Reviewline',
  tagline: 'เอเจนต์ดำเนินการสืบสวน มนุษย์เป็นผู้อนุมัติ',
  webmcpActive: 'WebMCP ทำงาน',
  webmcpInactive: 'WebMCP ไม่พร้อม',
  webmcpActiveTitle: 'ลงทะเบียนเครื่องมือ WebMCP บน document.modelContext แล้ว',
  webmcpInactiveTitle: 'ไม่มี WebMCP — ใช้เครื่องมือตรวจสอบในหน้าเพจแทน',
  reset: 'รีเซ็ต',
  resetDemoStateAria: 'รีเซ็ตสถานะการสาธิต',
  toolInspectorSummary: 'เครื่องมือตรวจสอบ WebMCP ({count} เครื่องมือ)',

  // ── Language toggle ───────────────────────────────────────────────────────
  languageToggleAria: 'เปลี่ยนภาษาเป็น {targetLang}',
  langEn: 'EN',
  langTh: 'TH',

  // ── Authority bar ─────────────────────────────────────────────────────────
  authorityBarAria: 'เส้นแบ่งอำนาจระหว่างเอเจนต์และมนุษย์',
  phaseEyebrow: 'ขั้นตอน',
  phaseInvestigation: 'ขั้นสืบสวน',
  phaseReplayReady: 'พร้อมร่างข้อเสนอ',
  phaseAwaitingHumanDecision: 'รอการตัดสินใจของมนุษย์',
  phaseDecided: 'บันทึกการตัดสินใจแล้ว',
  manifestTitle: 'สิทธิ์ของเอเจนต์ (capability manifest)',
  manifestHint: 'ลงทะเบียนบน document.modelContext เฉพาะขั้นตอนนี้เท่านั้น',
  exposureExposed: 'เปิดใช้',
  exposureWithheld: 'ปิดกั้น',
  humanOnlyTitle: 'การกระทำที่มนุษย์เท่านั้นทำได้',
  humanOnlyNote: 'ไม่เคยถูกลงทะเบียนเป็นเครื่องมือ WebMCP นี่คือการออกแบบผลิตภัณฑ์ตามสิทธิ์ขั้นต่ำสุด ไม่ใช่การรับประกันเชิงวิทยาการรหัสลับว่าจะป้องกันการสั่งการของเบราว์เซอร์ได้ทุกรูปแบบ',
  exposureNever: 'ไม่เคยลงทะเบียน',
  humanActionApprove: 'approve',
  humanActionReject: 'reject',
  humanActionActivate: 'activate',

  // ── Incident queue ────────────────────────────────────────────────────────
  incidentQueueTitle: 'เหตุการณ์',
  incidentQueueRegionAria: 'Incident queue',
  selectedBadge: 'เลือกอยู่',

  // ── Evidence panel ────────────────────────────────────────────────────────
  evidencePanelTitle: 'หลักฐาน',
  evidencePanelEmpty: 'เลือกเหตุการณ์จากคิวเพื่อตรวจสอบหลักฐาน',
  evidencePanelEmptyHint: 'เอเจนต์เข้าถึงมุมมองเดียวกันนี้ได้ด้วยการเรียก inspect_incident',
  evidenceWorkspaceAria: 'พื้นที่ทำงานหลักฐาน',
  evidenceForAria: 'หลักฐานสำหรับ {id}',
  traceHeading: 'ร่องรอยการทำงานของเอเจนต์',
  traceEntryAria: '{kind} เมื่อ {ts}',
  cohortHeading: 'กลุ่มกรณีสำหรับรันซ้ำ',
  blockedAtLabel: 'ถูกบล็อกเมื่อ',

  // ── Simulation view ───────────────────────────────────────────────────────
  simulationTitle: 'การจำลองการแก้ไขการ์ดเรล',
  simulationEmpty: 'ยังไม่มีการจำลอง',
  simulationEmptyHint: 'เรียก simulate_guardrail_patch เพื่อรันกฎที่เสนอกับกลุ่มกรณีทั้งหมด',
  simCompleted: 'เสร็จสิ้น',
  simAria: 'การจำลอง {simId}',
  resultIdentity: 'รหัสผลลัพธ์',
  baselinePolicy: 'นโยบายเดิม',
  candidatePolicy: 'นโยบายใหม่',
  executedAt: 'เวลาที่ประมวลผล',
  exactRule: 'กฎที่แน่นอน',
  ruleLabel: 'กฎ: {ruleKind}',
  thresholdLabel: 'เกณฑ์: {threshold}',
  enforcementLabel: 'การบังคับใช้: {enforcement}',
  noRegressions: 'ตรวจไม่พบการถดถอย',
  simNoRegressionDetail: 'กรณีที่กระตุ้นยังถูกบล็อก และกรณีควบคุมปกติยังได้รับอนุญาต',
  simRegressionFailedTitle: 'การควบคุมการถดถอยไม่ผ่าน',
  simRegressionFailedDetail: 'ผลลัพธ์เดิมเปลี่ยนไป {count} รายการ: {cases}',
  cohortResultsAria: 'ผลลัพธ์รวมของนโยบายใหม่',
  simLabelBlocked: 'ถูกบล็อก',
  simLabelAllowed: 'ได้รับอนุญาต',
  simLabelTotal: 'ทั้งหมด',
  simCaseTableAria: 'ผลลัพธ์รายกรณีระหว่างนโยบายเดิมและนโยบายใหม่',
  simColEvidenceCase: 'กรณีหลักฐาน',
  simColAmount: 'จำนวนเงิน',
  simColTransition: 'เดิม → ใหม่',
  simBadgeTrigger: 'TRIGGER',
  simBadgeBenign: 'BENIGN CONTROL',
  simNotMonetary: 'ไม่ใช่ตัวเงิน',
  counterfactualReplay: 'การจำลองย้อนหลังสมมุติ',

  // ── Review panel ──────────────────────────────────────────────────────────
  reviewPanelAria: 'แผงการตรวจสอบ',
  reviewPanelTitle: 'แผงการตรวจสอบโดยมนุษย์',
  noProposalPending: 'ไม่มีข้อเสนอที่รอดำเนินการ',
  noProposalDesc:
    'เอเจนต์จะร่างข้อเสนอได้เฉพาะเมื่อการรันซ้ำบล็อกกรณีที่กระตุ้น อนุญาตกรณีควบคุมปกติ และไม่มีการถดถอยเลย',
  humanReviewLine: 'ขอบเขตการตรวจสอบโดยมนุษย์',
  statusPending: 'รอดำเนินการ',
  statusApproved: 'อนุมัติแล้ว',
  statusRejected: 'ปฏิเสธแล้ว',
  rationaleHeading: 'เหตุผลประกอบ',
  notEligibleTitle: 'หลักฐานการจำลองไม่ผ่านเกณฑ์สำหรับการตัดสินใจของมนุษย์',
  notEligibleDesc:
    'ส่วนควบคุมการตัดสินใจยังไม่พร้อมใช้งาน กรุณารันการจำลองใหม่อีกครั้งโดยต้องมีกรณีที่กระตุ้นถูกบล็อก กรณีควบคุมปกติได้รับอนุญาต และไม่มีการถดถอย',
  decisionStateHeading: 'สถานะการตัดสินใจ',
  dsEnforcementOutcome: 'ผลลัพธ์การบังคับใช้',
  dsSimulationStatus: 'สถานะการจำลอง',
  dsHumanReview: 'การตรวจสอบโดยมนุษย์',
  dsIncidentState: 'สถานะเหตุการณ์',
  dsPolicyDeployment: 'การปรับใช้นโยบาย',
  simulationUnavailable: 'ไม่พร้อมใช้งาน',
  consequencesTitle: 'ผลที่ตามมาของการตัดสินใจ',
  consequenceConfirm: 'การยืนยันจะคงไว้ซึ่ง{rule}ที่เสนอ และ{unauthorized}',
  consequenceReject:
    'การปฏิเสธจะยกเลิกข้อเสนอนี้และคงการบล็อกปัจจุบันไว้ ทั้งสองการกระทำไม่มีการปรับใช้นโยบายจริงหรือแก้ไขระบบภายนอกใดๆ',
  rulePurchaseCap: 'เพดานการจัดซื้อ {threshold}',
  ruleRefundLimit: 'วงเงินคืนเงิน {threshold}',
  ruleEvidenceAge: 'อายุหลักฐานไม่เกิน {threshold}',
  ruleFallback: 'เกณฑ์ที่เสนอ',
  unauthorizedPurchase: 'คำสั่งซื้อที่ถูกบล็อกจะยังไม่ได้รับอนุมัติ',
  unauthorizedRefund: 'การคืนเงินจะยังไม่ได้รับอนุมัติ',
  unauthorizedDeployment: 'การปรับใช้จะยังถูกบล็อกจนกว่าจะมีหลักฐานและการรับรองที่ถูกต้อง',
  confirmActionPurchase: 'ยืนยัน{rule} · บล็อกการสั่งซื้อต่อไป',
  confirmActionRefund: 'ยืนยัน{rule} · บล็อกการคืนเงินต่อไป',
  confirmActionDeployment: 'ยืนยัน{rule} · บล็อกการปรับใช้ต่อไป',
  rejectProposalKeepBlock: 'ปฏิเสธข้อเสนอ · บังคับใช้การบล็อกปัจจุบันต่อไป',
  replaySummaryLabel: 'หลักฐานการจำลอง · {resultId}',
  replayFieldSimulation: 'การจำลอง',
  replayFieldResult: 'ผลลัพธ์',
  replayFieldTrigger: 'กรณีที่กระตุ้น',
  replayFieldControl: 'กรณีควบคุมปกติ',
  replayFieldRegressions: 'การถดถอย',
  recordedDecisionHeading: 'การตัดสินใจที่บันทึกไว้',
  recordedDecisionBody: '{status} เมื่อ {ts}',
  noteLabel: 'บันทึก',
  humanDecisionRequiredTitle: 'จำเป็นต้องมีการตัดสินใจโดยมนุษย์',
  requiredConfirmationsHint: 'กรอกข้อมูลยืนยันที่จำเป็นทั้งสามส่วนเพื่อเปิดใช้งานการตัดสินใจ',
  requiredMarker: 'จำเป็น',
  reviewerIdentityLabel: 'ตัวตนของผู้ตรวจสอบ',
  reviewNoteLabel: 'บันทึกการตรวจสอบ',
  confirmEvidenceLabel:
    'ข้าพเจ้าได้ตรวจสอบหลักฐาน กรณีที่กระตุ้น กรณีควบคุมปกติ และผลกระทบต่อการปรับใช้แล้ว',
  decisionRecorded: 'บันทึกการตัดสินใจแล้ว',
  decisionRecordedNote: 'บันทึกการตัดสินใจของมนุษย์แล้ว ไม่มีการปรับใช้นโยบายภายนอก',
  purchaseRemainsBlocked: 'การสั่งซื้อยังคงถูกบล็อก',
  refundRemainsBlocked: 'การคืนเงินยังคงถูกบล็อก',
  deploymentRemainsBlocked: 'การปรับใช้ยังคงถูกบล็อก',
  completedStatus: 'เสร็จสิ้น',
  awaitingHumanDecision: 'รอการตัดสินใจของมนุษย์',
  openStatus: 'เปิดอยู่',
  noExternalDeployment: 'ไม่มีการปรับใช้ระบบภายนอก',

  // ── Audit log ─────────────────────────────────────────────────────────────
  auditLogTitle: 'บันทึกการตัดสินใจของมนุษย์',
  auditLogEmpty: 'ยังไม่มีรายการตรวจสอบ การตัดสินใจจะปรากฏที่นี่หลังจากการตรวจสอบโดยมนุษย์',
  auditLogAria: 'บันทึกการตรวจสอบ',

  // ── Session record ────────────────────────────────────────────────────────
  sessionRecordAria: 'บันทึกเซสชันแบบผนวกต่อเท่านั้น',
  sessionRecordSummary: 'บันทึกเซสชัน · {count} เหตุการณ์',
  sessionTimelineTitle: 'ไทม์ไลน์เซสชัน',
  sessionTimelineEmpty: 'การเปลี่ยนแปลงความสามารถและการเรียกใช้เครื่องมือจะปรากฏที่นี่',
  sessionTimelineAria: 'ไทม์ไลน์เซสชัน',

  // ── Tool inspector ────────────────────────────────────────────────────────
  toolInspectorTitle: 'ชุดทดสอบเครื่องมือ',
  toolInspectorAria: 'เครื่องมือตรวจสอบ WebMCP',
  registeredStatus: 'ลงทะเบียนแล้ว ({count})',
  fallbackStatus: 'WebMCP ไม่พร้อมใช้งาน — โหมดเครื่องมือตรวจสอบสำหรับนักพัฒนา',
  inputSchemaSummary: 'สคีมาข้อมูลขาเข้า',
  executeTool: 'สั่งรัน',
  executingTool: 'กำลังสั่งรัน…',
  runHeroJourney: 'รันการสาธิต 3 ขั้นตอน',
  runningHeroJourney: 'กำลังรันกระบวนการเอเจนต์…',
  parametersLabel: 'พารามิเตอร์ (JSON):',
  toolOutputLabel: 'ผลลัพธ์ล่าสุด:',

  // ── Guide modal ───────────────────────────────────────────────────────────
  guideButton: 'แนวคิด & ตัวอย่างงาน',
  guideButtonAria: 'เปิดคู่มือ Reviewline สไตล์ ELI5 และตัวอย่างการใช้งานจริง',
  guideButtonTitle: 'เรียนรู้การทำงานของ Reviewline ทำไมต้องใช้ WebMCP และตัวอย่างการใช้งานจริง (กด ?)',
  guideModalTitle: 'คู่มือ Reviewline: อธิบายง่ายๆ สไตล์ ELI5 & ตัวอย่างการใช้งานจริง',
  guideModalBadge: 'คู่มือ / ELI5',
  guideModalCloseAria: 'ปิดหน้าต่างคู่มือ',
  guideModalClose: 'ปิด',
  guideSectionsAria: 'หัวข้อในคู่มือ',
  guideTabConcept: 'แนวคิด ELI5',
  guideTabWebmcp: 'ทำไมต้อง WebMCP?',
  guideTabUsecases: 'ตัวอย่างงานจริง',
  guideTabTour: 'ทัวร์ 3 นาที',
  guideConceptTitle: 'โมเดลทางความคิดแบบเข้าใจง่าย (ELI5)',
  guideConceptSubtitle: 'เหตุใดเราจึงไม่ควรปล่อยให้ AI ทำงานอัตโนมัติ 100% โดยไร้การกำกับดูแล',
  guideDetectiveTitle: 'AI คือ “นักสืบ”',
  guideDetectiveDesc: 'AI Agent เก่งกาจเรื่องการสังเคราะห์: เจาะลึก Log มหาศาล, ตรวจสอบ Audit Trail ข้ามระบบ, ทดลองรันกฎใหม่ (Replay) และจำลองผลลัพธ์ว่ากฎที่เสนอนั้นสกัดกั้นการโจมตีได้จริงโดยไม่ไปรบกวนรายการปกติของผู้ใช้ทั่วไป',
  guideJudgeTitle: 'มนุษย์คือ “ผู้พิพากษา”',
  guideJudgeDesc: 'การกระทำที่มีความเสี่ยงสูง (การสั่งจ่ายเงิน, การอนุมัตินโยบาย, การปรับใช้โค้ดขึ้น Production) ต้องมีความรับผิดชอบทางกฎหมายและเจตนาของมนุษย์กำกับ AI มีหน้าที่เตรียมสำนวนและหลักฐาน แต่มนุษย์คือคนเดียวที่ถือค้อนเคาะคำตัดสิน',
  guideWebmcpTitle: 'ทำไมต้องใช้ WebMCP แทนการให้บอทคลิกหน้าจอ?',
  guideWebmcpSubtitle: 'เปลี่ยนจากการขูดหน้าเว็บ (DOM Scraping) ที่เปราะบาง สู่การคุมสิทธิ์แบบ Least-Authority ผ่าน WebMCP',
  guideWebmcpPoint1Title: '1. ซิงก์สถานะด้วยโครงสร้างข้อมูลที่แม่นยำ',
  guideWebmcpPoint1Desc: 'แทนที่จะให้ Agent เดาพิกัดปุ่มหรือกวาดอ่าน HTML ที่เสี่ยงโดน Prompt Injection ตัวเบราว์เซอร์จะเชื่อมต่อผ่าน WebMCP Tools (document.modelContext) ซึ่งอัปเดตหน้าจอตรงกันกับที่มนุษย์กำลังมองเห็นแบบเรียลไทม์',
  guideWebmcpPoint2Title: '2. วงจรสิทธิ์แบบ Least-Authority (เปิดเฉพาะสิทธิ์ที่จำเป็น)',
  guideWebmcpPoint2Desc: 'เครื่องมือจะถูกลงทะเบียนตามเฟสงาน: เริ่มจากสิทธิ์สืบสวน -> สิทธิ์จำลองกฎหลังตรวจเคส -> สิทธิ์ร่างข้อเสนอหลัง Replay สำเร็จ และเมื่อเข้าสู่ขั้นตอนรอการตัดสินใจ สิทธิ์การร่างจะถูกเพิกถอนออกทันที',
  guideWebmcpPoint3Title: '3. ขอบเขตความปลอดภัยที่ AI แตะต้องไม่ได้',
  guideWebmcpPoint3Desc: 'การกระทำ “อนุมัติ” (Approve) หรือ “ปฏิเสธ” (Reject) จะไม่มีวันถูกลงทะเบียนเป็นเครื่องมือ WebMCP เด็ดขาด AI จึงไม่สามารถสั่งรันคำสั่งเหล่านี้ได้เลย ต้องเป็นมนุษย์คลิกบนหน้าจอเท่านั้น',
  guideUsecasesTitle: '4 ตัวอย่างการใช้งานจริงในระดับองค์กร',
  guideUsecasesSubtitle: 'สถาปัตยกรรมนี้ไปประยุกต์ใช้กับงานประเภทใดได้บ้าง',
  guideUsecase1Title: '1. ระบบจัดซื้อและตรวจสอบการเบิกจ่าย (Procurement Overrides)',
  guideUsecase1Desc: 'บอทจัดซื้อเจอข้อความแปลกปลอมจากซัพพลายเออร์ที่พยายามหลบเลี่ยงเพดานงบประมาณ AI ตรวจจับร่องรอย จำลองการตั้ง Cap วงเงิน และพิสูจน์ว่าใบสั่งซื้อปกติจะไม่โดนบล็อก ก่อนส่งให้หัวหน้าฝ่ายการเงินกดอนุมัติ',
  guideUsecase1Demo: 'เทียบเท่าในเดโม: เหตุการณ์ inc-001',
  guideUsecase2Title: '2. ระบบบริการลูกค้าและการเคลมคืนเงิน (Customer Support Refunds)',
  guideUsecase2Desc: 'บอทบริการลูกค้าผูกบัญชีผิดและพยายามคืนเงินเกินเกณฑ์ที่กำหนด AI รวบรวมประวัติลูกค้า ทดสอบเงื่อนไขข้อจำกัดนโยบาย และร่างข้อเสนอให้ผู้จัดการฝ่ายบริการลูกค้าเป็นผู้ชี้ขาดการจ่ายเงิน',
  guideUsecase2Demo: 'เทียบเท่าในเดโม: เหตุการณ์ inc-002',
  guideUsecase3Title: '3. ประตูกั้นการ Deploy ในงาน DevOps (CI/CD Deployment Gates)',
  guideUsecase3Desc: 'บอท Deployment พยายามปล่อยโค้ดที่มีผลทดสอบเก่าเกินไปและไม่มีแผน Rollback รองรับ AI ตรวจพบและเสนอให้ระงับการปล่อยระบบ วิศวกร SRE เข้ามาตรวจสอบโครงสร้างพื้นฐานก่อนให้ไฟเขียว',
  guideUsecase3Demo: 'เทียบเท่าในเดโม: เหตุการณ์ inc-003',
  guideUsecase4Title: '4. ระบบความปลอดภัย AI และป้องกัน Jailbreak (AI Safety & Defense)',
  guideUsecase4Desc: 'แชทบอทขององค์กรถูกผู้ใช้พยายามส่ง Prompt Injection เจาะระบบ AI วิเคราะห์ทิศทางการโจมตี ร่างแพตช์ Guardrail ตัวใหม่ และ Replay เทียบกับคลังคำถามปกติของลูกค้าเพื่อการันตีว่าไม่มีผลข้างเคียง ก่อนทีมความปลอดภัยจะสั่งเปิดใช้งาน',
  guideUsecase4Demo: 'เหมาะสำหรับระบบ Gateway กำกับดูแลโมเดล LLM ในองค์กร',
  guideBadgeCritical: 'วิกฤต',
  guideBadgeHigh: 'สูง',
  guideBadgeMedium: 'ปานกลาง',
  guideBadgeSafety: 'ความปลอดภัย',
  guideTourTitle: 'วิธีทดลองใช้งานจริงใน 3 นาที',
  guideTourSubtitle: 'สัมผัสการทำงานจริงด้วยตนเองผ่านชุดทดสอบเครื่องมือ WebMCP ที่ด้านล่างของหน้าเพจ',
  guideTourStep1: 'เปิดชุดทดสอบเครื่องมือที่แถบด้านล่างของหน้าจอ แล้วรัน inspect_incident สำหรับ inc-001',
  guideTourStep2: 'รัน simulate_guardrail_patch โดยระบุ threshold เป็น 50000 เพื่อจำลองการบล็อกยอดจัดซื้อ',
  guideTourStep3: 'รัน draft_review_gate เพื่อสร้างข้อเสนอ แล้วสังเกตว่าสิทธิ์การร่างจะหายไปจาก capability manifest ทันที',
  guideTourStep4: 'ในฐานะมนุษย์ผู้ตรวจทาน กรอกชื่อ บันทึกการตรวจสอบ ติ๊กยืนยันหลักฐาน แล้วเลือกยืนยันหรือปฏิเสธ',
}
